import type { Cart } from '@jane/shared/types';

/**
 * @returns the number of items in the cart
 */
export const cartSize = (cart?: Cart | Record<string, never> | null): number =>
  (cart?.products ?? []).reduce(
    (runningTotal, { count }) => runningTotal + count,
    0
  );
